import { useI18n } from 'vue-i18n'
import { useToast } from '@ai/ui-components/toast'
import { LIST_ACTION_ICONS } from '@/components/BusinessLogic/TableActions'

export const useCopyCallLink = () => {
  const { t, locale } = useI18n({ useScope: 'global' })
  const toast = useToast()

  const copyCallLink = async (callId: string) => {
    const url = `${window.location.origin}/${locale.value}/cold-monitoring?callId=${callId}`
    try {
      await navigator.clipboard.writeText(url)
      toast.success(t('link_copied'))
    } catch {
      toast.error(t('failed_to_copy'), { title: t('error_occurred') })
    }
  }

  const getCopyLinkAction = (callId: string) => ({
    label: t('copy_link'),
    value: 'copyLink' as const,
    icon: LIST_ACTION_ICONS.copyLink,
    handler: () => copyCallLink(callId),
    dataTestid: 'action-copy-link',
  })

  return { copyCallLink, getCopyLinkAction }
}
